import { notificationStore } from '@pascal/pascal-core/shared/core/store';

class NotificationService {

  setResponseNotification(type) {
    notificationStore.setNotificationType(type);
    this.clearNotifications();
  }

  clearNotifications() {
    setTimeout(() => {
      notificationStore.setNotificationType(null);
    }, 1000);
  }

}

export const notificationService = new NotificationService;